class BlockerFunctionRuleSet {
  constructor(rules = null) {
    if(rules) {
      this.rules = rules.map((rule) => {
        rule.regexp = this.generateRegexp(rule);
        return rule;
      });
    }
    else
    {
      this.rules = []; //array of objects with structure: {symbol: "asd", caseSensitive: bool}
    }
  }
}

BlockerFunctionRuleSet.prototype.addElement = function(symbol = "", caseSensitive = false, wholeWord = false) {
  let rule = {
    symbol:symbol,
    caseSensitive: caseSensitive,
    wholeWord: wholeWord
  }
  rule.regexp = this.generateRegexp(rule);
  this.rules.push(rule);
}

BlockerFunctionRuleSet.prototype.generateRegexp = function(rule) {
  let pattern = ( "(.*"
    + ((rule.wholeWord) ? "\\b" : '')
    + rule.symbol
    + ((rule.wholeWord) ? "\\b" : '')
    + ".*)" );
  //notice that 'i' flag makes RegExp caseINsensitive
  return new RegExp(pattern, (rule.caseSensitive) ? '' : 'i');
}

BlockerFunctionRuleSet.prototype.hasRules = function() { return this.rules.length !== 0 }
BlockerFunctionRuleSet.prototype.getRules = function() { return this.rules }
BlockerFunctionRuleSet.prototype.deleteRule = function(id) { this.rules.splice(id, 1) }



module.exports = BlockerFunctionRuleSet;
